import { AllSystemProps } from '@moonpig/launchpad-system'

export type ProductModule = AllSystemProps & {
  withContainer?: boolean
}

export enum VariantType {
  price,
  size,
}
